import * as React from "react";

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function Banner() {
  function handleSubmitClaim(e){
    e.preventDefault();
    alert('Claim')
  }

  return (
    <S.Container>
      <S.Content>
        <h1>Turn Your Fitness</h1>
        <h1>Content Into Paid</h1>
        <h1>Subscribers For <span className="spotlight">FREE</span>!</h1>
        <S.Input onSubmit={handleSubmitClaim}>
          <span>app.ujoose.com/</span>
          <input type="text" placeholder="enter name" />
          <button type="submit">Claim</button>
        </S.Input>
        <S.Info>
          <h2 className="recursive">Type your name above to get started !</h2>
          <S.StaticImageNormal>
            <StaticImage
              src="../../images/arrow.png"
              alt="Arrow the register mobile"
              placeholder="blurred"
              layout="fixed"
              width={70}
              height={70}
            />
          </S.StaticImageNormal>
          <S.StaticImageResponsive>
            <StaticImage
              src="../../images/arrow.png"
              alt="Arrow the register mobile"
              placeholder="blurred"
              layout="fixed"
              width={50}
              height={50}
            />
          </S.StaticImageResponsive>
        </S.Info>
      </S.Content>
      <S.Image>
        <S.GradientW />
        <S.GradientH />
        <StaticImage
          src="../../images/banner-background.jpg"
          alt="Background the banner"
          placeholder="blurred"
          layout="constrained"
        />
      </S.Image>
    </S.Container>
  )
}